import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Globe, ChevronDown } from 'lucide-react';

const LANGS = [
  { code: 'it', label: 'Italiano',  flag: '🇮🇹' },
  { code: 'en', label: 'English',   flag: '🇬🇧' },
  { code: 'es', label: 'Español',   flag: '🇪🇸' },
  { code: 'fr', label: 'Français',  flag: '🇫🇷' },
  { code: 'de', label: 'Deutsch',   flag: '🇩🇪' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const dropRef = useRef(null);

  const current = LANGS.find((l) => l.code === (i18n.language || 'it').slice(0, 2)) || LANGS[0];

  useEffect(() => {
    const onClickOutside = (e) => {
      if (dropRef.current && !dropRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onClickOutside);
    return () => document.removeEventListener('mousedown', onClickOutside);
  }, []);

  const change = (code) => {
    i18n.changeLanguage(code);
    setOpen(false);
    if (typeof document !== 'undefined') {
      document.documentElement.lang = code;
    }
  };

  return (
    <div className="relative" ref={dropRef}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-[#A1A1AA] hover:text-white hover:bg-white/5 transition-colors"
        aria-haspopup="true"
        aria-expanded={open}
        data-testid="lang-switcher-toggle"
      >
        <Globe size={16} />
        <span className="hidden sm:inline">{current.flag} {current.code.toUpperCase()}</span>
        <span className="sm:hidden">{current.flag}</span>
        <ChevronDown size={14} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-44 rounded-xl bg-[#111111] border border-white/10 shadow-xl py-1 z-50">
          {LANGS.map((l) => (
            <button
              key={l.code}
              type="button"
              onClick={() => change(l.code)}
              className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-3 hover:bg-white/5 transition-colors ${
                l.code === current.code ? 'text-white' : 'text-[#A1A1AA]'
              }`}
            >
              <span className="text-lg leading-none">{l.flag}</span>
              <span className="flex-1">{l.label}</span>
              {l.code === current.code && <span className="text-[#0055FF]">●</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher;
